<template>
    <section class="results wrapper" :class="{ 'results--collapsed': isCollapsed }" v-if="hasResults">
        <h2 class="section-title">Eredményei</h2>

        <button class="results__filter-btn button" @click="showFilterPane" v-show="isFilterable && !filterPane">Szűrés<span> és rendezés</span></button>

        <div class="results__container">
            <nav class="results__filters res-filters" v-show="filterPane">
                <div class="res-filters__col">
                    <h6 class="res-filters__group-label">Verseny-típusa</h6>
                    <div class="res-filters__list">
                        <button class="res-filter" :class="filterClass('competition_type', 'olympics')" @click="toggleFilter('competition_type', 'olympics')">Olimpia</button>
                        <button class="res-filter" :class="filterClass('competition_type', 'wc')" @click="toggleFilter('competition_type', 'wc')">Világbajnokság</button>
                        <button class="res-filter" :class="filterClass('competition_type', 'ec')" @click="toggleFilter('competition_type', 'ec')">Európa-bajnokság</button>
                    </div>
                </div>
                <div class="res-filters__col">
                    <h6 class="res-filters__group-label">Helyezés</h6>
                    <div class="res-filters__list">
                        <button class="res-filter" :class="filterClass('place', 1)" @click="toggleFilter('place', 1)">Első</button>
                        <button class="res-filter" :class="filterClass('place', 2)" @click="toggleFilter('place', 2)">Második</button>
                        <button class="res-filter" :class="filterClass('place', 3)" @click="toggleFilter('place', 3)">Harmadik</button>
                        <button class="res-filter" :class="filterClass('composite_place', '4+')" @click="toggleFilter('composite_place', '4+')">4+</button>
                    </div>
                </div>
                <div class="res-filters__col">
                    <h6 class="res-filters__group-label">Lokáció</h6>
                    <div class="res-filters__list">
                        <button class="res-filter" :class="filterClass('location', 'home')" @click="toggleFilter('location', 'home')">Hazai rendezésű</button>
                        <button class="res-filter" :class="filterClass('location', 'abroad')" @click="toggleFilter('location', 'abroad')">Külföldi rendezésű</button>
                    </div>
                </div>

                <div class="res-filters__actions" v-if="hasAppliedFilter">
                    <a class="res-filters__action" @click="removeAllFilters">Összes szűrő törlése</a>
                </div>
            </nav>

            <div class="result" :key="result.id" v-for="result in filteredResults">
                <div class="result__col result__col--icon">
                    <div class="result__laurel" v-if="result.competition.competition_type == 'olympics'">
                        <svg viewBox="0 0 751 751">
                            <g stroke="none" stroke-width="1" fill="#000" fill-rule="evenodd">
                                <path d="M300.1,526.6 C287.6,537.9 275.2,543.6 262.7,547.9 C250.2,552 237.8,553.7 225.3,553.7 C212.8,553.7 200.4,552 187.9,547.9 C175.4,543.6 163,538 150.5,526.6 C163,515.2 175.4,509.5 187.9,505.3 C200.4,501.3 212.8,499.5 225.3,499.5 C237.8,499.6 250.2,501.3 262.7,505.3 C275.2,509.6 287.7,515.2 300.1,526.6 Z M428.8,536.1 C428,552.9 423.2,565.7 417.4,577.6 C411.5,589.3 403.9,599.3 395.1,608.2 C386.3,617 376.2,624.6 364.6,630.6 C352.8,636.4 339.9,641.2 323.1,642 C323.9,625.1 328.7,612.3 334.4,600.5 C340.4,588.8 347.9,578.8 356.8,570 C365.7,561.2 375.7,553.6 387.4,547.7 C399.2,541.7 412,536.9 428.8,536.1 Z M526.6,451.8 C537.9,464.3 543.6,476.7 547.9,489.2 C552,501.7 553.7,514.1 553.7,526.6 C553.7,539.1 552,551.5 547.9,564 C543.6,576.5 538,588.9 526.6,601.4 C515.2,588.9 509.5,576.5 505.3,564 C501.3,551.5 499.5,539.1 499.5,526.6 C499.6,514.1 501.3,501.7 505.3,489.2 C509.6,476.7 515.2,464.2 526.6,451.8 Z M536.1,323.1 C552.9,323.9 565.7,328.7 577.6,334.5 C589.3,340.4 599.3,348 608.2,356.8 C617,365.6 624.6,375.6 630.6,387.3 C636.4,399.1 641.2,412 642,428.8 C625.1,428 612.3,423.2 600.5,417.5 C588.8,411.5 578.8,404 570,395.1 C561.2,386.2 553.6,376.2 547.7,364.5 C541.7,352.7 536.9,339.9 536.1,323.1 Z M451.8,225.3 C464.3,214 476.7,208.3 489.2,204 C501.7,199.9 514.1,198.2 526.6,198.2 C539.1,198.2 551.5,199.9 564,204 C576.5,208.3 588.9,213.9 601.4,225.3 C588.9,236.7 576.5,242.4 564,246.6 C551.5,250.6 539.1,252.4 526.6,252.4 C514.1,252.3 501.7,250.6 489.2,246.6 C476.7,242.3 464.2,236.7 451.8,225.3 Z M323.1,215.8 C323.9,199 328.7,186.2 334.5,174.3 C340.4,162.6 348,152.6 356.8,143.7 C365.6,134.9 375.6,127.3 387.3,121.3 C399.1,115.5 412,110.7 428.8,109.9 C428.1,126.8 423.2,139.6 417.5,151.4 C411.5,163.1 404,173.1 395.1,181.9 C386.2,190.7 376.2,198.3 364.5,204.2 C352.7,210.2 339.9,215 323.1,215.8 Z M225.3,300.1 C214,287.6 208.3,275.2 204,262.7 C199.9,250.2 198.2,237.8 198.2,225.3 C198.2,212.8 199.9,200.4 204,187.9 C208.3,175.4 213.9,163 225.3,150.5 C236.7,163 242.4,175.4 246.6,187.9 C250.6,200.4 252.4,212.8 252.4,225.3 C252.3,237.8 250.6,250.2 246.6,262.7 C242.3,275.2 236.7,287.7 225.3,300.1 Z M215.8,428.8 C199,428 186.2,423.2 174.3,417.4 C162.6,411.5 152.6,403.9 143.7,395.1 C134.9,386.3 127.3,376.3 121.3,364.6 C115.5,352.8 110.7,339.9 109.9,323.1 C126.8,323.8 139.6,328.7 151.4,334.4 C163.1,340.4 173.1,347.9 181.9,356.8 C190.7,365.7 198.3,375.7 204.2,387.4 C210.2,399.2 215,412 215.8,428.8 Z M225.3,750.9 C214,738.4 208.3,726 204,713.5 C199.9,701 198.2,688.6 198.2,676.1 C198.2,663.6 199.9,651.2 204,638.7 C208.3,626.2 213.9,613.8 225.3,601.3 C236.7,613.8 242.4,626.2 246.6,638.7 C250.6,651.2 252.4,663.6 252.4,676.1 C252.3,688.6 250.6,701 246.6,713.5 C242.3,726 236.7,738.5 225.3,750.9 Z M534.6,747.6 C517.8,746.8 505,742 493.1,736.2 C481.4,730.2 471.4,722.7 462.5,713.9 C453.7,705.1 446.1,695.1 440.1,683.4 C434.3,671.6 429.5,658.7 428.7,641.9 C445.6,642.7 458.4,647.5 470.2,653.3 C481.9,659.3 491.9,666.8 500.7,675.7 C509.5,684.6 517.1,694.6 523,706.3 C529,718 533.8,730.8 534.6,747.6 Z M750.9,526.6 C738.4,537.9 726,543.6 713.5,547.9 C701,552 688.6,553.7 676.1,553.7 C663.6,553.7 651.2,552 638.7,547.9 C626.2,543.6 613.8,538 601.3,526.6 C613.8,515.2 626.2,509.5 638.7,505.3 C651.2,501.3 663.6,499.5 676.1,499.5 C688.6,499.6 701,501.3 713.5,505.3 C726,509.6 738.5,515.2 750.9,526.6 Z M747.6,217.3 C746.8,234.1 742,246.9 736.2,258.8 C730.3,270.5 722.7,280.5 713.9,289.4 C705.1,298.2 695.1,305.8 683.4,311.8 C671.6,317.6 658.7,322.4 641.9,323.2 C642.7,306.3 647.5,293.5 653.3,281.7 C659.3,270 666.8,260 675.7,251.2 C684.6,242.4 694.6,234.8 706.3,228.9 C718,222.9 730.8,218.1 747.6,217.3 Z M526.6,0.9 C537.9,13.4 543.6,25.8 547.9,38.3 C552,50.8 553.7,63.2 553.7,75.7 C553.7,88.2 552,100.6 547.9,113.1 C543.6,125.6 538,138 526.6,150.5 C515.2,138 509.5,125.6 505.3,113.1 C501.3,100.6 499.5,88.2 499.5,75.7 C499.6,63.2 501.3,50.8 505.3,38.3 C509.6,25.9 515.2,13.4 526.6,0.9 Z M217.3,4.3 C234.1,5.1 246.9,9.9 258.8,15.7 C270.5,21.6 280.5,29.2 289.4,38 C298.2,46.8 305.8,56.8 311.8,68.5 C317.6,80.3 322.4,93.2 323.2,110 C306.3,109.3 293.5,104.4 281.7,98.7 C270,92.7 260,85.2 251.2,76.3 C242.4,67.4 234.8,57.4 228.9,45.7 C222.9,33.9 218.1,21.1 217.3,4.3 Z M0.9,225.3 C13.4,214 25.8,208.3 38.3,204 C50.8,199.9 63.2,198.2 75.7,198.2 C88.2,198.2 100.6,199.9 113.1,204 C125.6,208.3 138,213.9 150.5,225.3 C138,236.7 125.6,242.4 113.1,246.6 C100.6,250.6 88.2,252.4 75.7,252.4 C63.2,252.3 50.8,250.6 38.3,246.6 C25.9,242.3 13.4,236.7 0.9,225.3 Z M4.3,534.6 C5.1,517.8 9.9,505 15.7,493.1 C21.6,481.4 29.2,471.4 38,462.5 C46.8,453.7 56.8,446.1 68.5,440.1 C80.3,434.3 93.2,429.5 110,428.7 C109.2,445.6 104.4,458.4 98.6,470.2 C92.6,481.9 85,491.9 76.2,500.7 C67.3,509.5 57.3,517.1 45.6,523 C33.9,529 21.1,533.8 4.3,534.6 Z" id="Combined-Shape"></path>
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="result__col result__col--year">
                    <div class="result__year">{{result.competition.year}}</div>
                </div>
                <div class="result__col result__col--date-n-location">
                    <time class="result__date" :datetime="result.competition.display_date_start">{{getNiceDate(result.competition.display_date_start, true, true)}}</time>
                    <div class="result__location">
                        <div class="result__location__city">{{result.competition.city}}</div>
                        <div class="result__location__country" v-if="!result.competition.is_domestic">{{result.competition.country}}</div>
                    </div>
                </div>
                <div class="result__col result__col--competition">
                    <div class="result__competition-name">{{result.competition.display_name}}</div>
                    <div class="result__team" v-if="result.is_team">
                        <template :key="competitor.id" v-for="competitor in result.competitors">
                            <a class="result__competitor result__competitor--is-link" :href="'/redir/p/' + competitor.id" target="_blank" v-if="competitor.published">{{competitor.full_name}}</a>
                            <span class="result__competitor" v-else>{{competitor.full_name}}</span>
                        </template>

                    </div>
                </div>
                <div class="result__col result__col--event">
                    <span class="result__event" v-if="result.competition_event">{{result.competition_event.display_name}}</span>
                </div>
                <div class="result__col result__col--result">
                    <div class="result__place" v-if="result.place">{{result.place}}</div>
                    <div class="" v-if="result.unplaced">Helyezetlen</div>
                </div>
            </div>

            <div class="results__no-results" v-if="!hasFilteredResults">
                Nincs megjeleníthető eredmény a jelenlegi szűrési feltételek szerint. <span class="results__no-results__action" @click="removeAllFilters">Szűrők törlése</span>
            </div>
        </div>
        <div class="results__expand-btn" @click="expand" v-if="isCollapsed">Összes eredmény</div>
    </section>
</template>

<script>
import niceDatesMixin from 'js/mixins/nice_dates_mixin'

export default {
    mixins: [niceDatesMixin],

    props: {
        person: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            uncollapsed: false,
            filterPane: false,
            filters: {
                competition_type: [],
                place: [],
                composite_place: [],
                location: [],
            },
        }
    },

    computed: {
        results() {
            return this.person && this.person.results
        },

        filteredResults() {
            if (!this.results) {
                return []
            }
            let filtered = this.results

            if (this.filters.competition_type.length > 0) {
                filtered = filtered.filter(r => this.filters.competition_type.includes(r.competition.competition_type))
            }

            if (this.filters.place.length > 0) {
                filtered = filtered.filter(r => this.filters.place.includes(r.place))
            }

            // TODO
            if (this.filters.composite_place.length > 0) {
                filtered = filtered.filter(r => this.filters.composite_place.includes('4+') && r.place >= 4)
            }

            // TODO
            if (this.filters.location.length > 0) {
                filtered = filtered.filter(r => (this.filters.location.includes('home') && r.competition.country === "Magyarország") || (this.filters.location.includes('abroad') && r.competition.country !== "Magyarország"))
            }

            return filtered
        },

        resultsCount() {
            return this.results ? this.results.length : 0
        },

        hasResults() {
            return this.resultsCount > 0
        },

        hasFilteredResults() {
            return this.filteredResults.length > 0
        },

        isCollapsed() {
            if (!this.uncollapsed && this.resultsCount > 4) {
                return true
            }
            return false
        },

        isFilterable() {
            return this.resultsCount > 4
        },

        hasAppliedFilter() {
            let hasAppliedFilter = false
            for (const f in this.filters) {
                if (this.filters[f].length > 0) {
                    hasAppliedFilter = true
                    break;
                }
            }
            return hasAppliedFilter
        },
    },

    methods: {
        expand() {
            this.uncollapsed = true
        },

        showFilterPane() {
            if (!this.isFilterable) {
                return false
            }

            if (this.isCollapsed) {
                this.expand()
            }
            this.filterPane = true
        },

        toggleFilter(filter, value) {
            if (this.filters[filter].includes(value)) {
                this.filters[filter] = this.filters[filter].filter(v => v !== value)
            } else {
                this.filters[filter].push(value)
            }
        },

        filterClass(filter, value) {
            return this.filters[filter].includes(value) ? "res-filter--applied" : ""
        },

        removeAllFilters() {
            for (const f in this.filters) {
                this.filters[f] = []
            }
        }
    }
}
</script>
